import { render, staticRenderFns } from "./TherapistInformationChips.vue?vue&type=template&id=3e8e6f68&scoped=true"
import script from "./TherapistInformationChips.vue?vue&type=script&lang=js"
export * from "./TherapistInformationChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8e6f68",
  null
  
)

export default component.exports